import professionalIcon from "@assets/images/kyc/PROFESSIONAL.svg";
import teacherIcon from "@assets/images/kyc/TEACHER.svg";

export const USER_TYPE_INFOS = {
	PROFESSIONAL: professionalIcon,
	TEACHER: teacherIcon,
} as const;
